import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import ConfirmationModal from "views/admin/components/ConfirmationModal";
import { parseAndSetFlag } from "utils/Utils";

const DisbursalSendBack = ({
  loanApplicationId,
  classes,
  callInProgress,
  setCallInProgress,
  toastUpdate,
  size = "small",
  style,
  featureFlags,
}) => {
  if (!parseAndSetFlag(featureFlags?.enabelSendBackOnDisbursal)) {
    return null;
  }

  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [remarks, setRemarks] = useState("");

  const { authToken } = useSelector((state) => state.login.authData);
  const { username } = useSelector((state) => state.login.userData);
  const navigate = useNavigate();
  const returnDate = new Date().toLocaleString("sv-SE").replace(" ", "T");
  const sendBack = async () => {
    if (!remarks.trim()) {
      toastUpdate("Error", "Please enter remarks", true);
      return;
    }

    setCallInProgress(true);

    try {
      const result = await apiHandler({
        url: `${endpoint.SEND_BACK_BY_ID}${loanApplicationId}?applicationStatus=INPROCESS&remarks=${encodeURIComponent(
          remarks.trim()
        )}&username=${encodeURIComponent(username)}&returnDate=${encodeURIComponent(
          returnDate
        )}`,
        method: "PUT",
        authToken,
      });

      if (result?.data?.error_code) {
        toastUpdate(
          "Error",
          result?.data?.user_description,
          true
        );
      } else {
        setRemarks("");
        navigate("/loanservice/disbursal", {
          state: { from: "" },
        });
      }
    } catch (error) {
      toastUpdate(
        "Error",
        error?.message || "Unable to send back this case",
        true
      );
    } finally {
      setCallInProgress(false);
    }
  };

  const closeConfirmation = () => {
    setConfirmationOpen(false);
    setRemarks("");
  };

  return (
    <>
      <Button
        size={size}
        className={classes.nextButton1}
        disabled={callInProgress}
        onClick={() => setConfirmationOpen(true)}
        style={style}
      >
        Send Back
      </Button>

      {confirmationOpen && (
        <ConfirmationModal
          confirmationModal={confirmationOpen}
          confirmationModalHeader="Disbursal"
          confirmationModalMsg="Are you sure want to Send-Back this case"
          handleNegativeButton={closeConfirmation}
          handlePositiveButton={() => {
            if (!remarks.trim()) {
              toastUpdate("Error", "Please enter remarks", true);
              return;
            }
          
            closeConfirmation();
            sendBack();
          }}
          customContent={
            <TextField
              fullWidth
              multiline
              rows={3}
              variant="outlined"
              label="Remarks"
              placeholder="Enter remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              required
              style={{
                marginTop: "10px",
              }}
            />
          }
        />
      )}
    </>
  );
};

DisbursalSendBack.propTypes = {
  loanApplicationId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  classes: PropTypes.object.isRequired,
  callInProgress: PropTypes.bool.isRequired,
  setCallInProgress: PropTypes.func.isRequired,
  toastUpdate: PropTypes.func.isRequired,
  size: PropTypes.string,
  style: PropTypes.object,
  featureFlags: PropTypes.object,
};

export default DisbursalSendBack;